import { BusTopBg, BusBottomBg } from '@/assets/icons/bus/_';
import { SeatingType, SeatStatusType } from '@/constants';
import { range } from 'lodash';
import './styles.less';
import BusMiddleBg from '@/assets/icons/bus/bus-middle-bg.png';
import { Spin } from 'antd';
import { TripSeatingModel, AvailableSeatModel } from '@/__generated';
import { BusDoorIcon, FridgeIcon, SeatIcon, ToiletIcon } from '@/assets/icons/bus/_';
import { BusEntityType } from '@/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';

const toDict = (arr: AvailableSeatModel[]) => {
  let dict = {};
  arr.forEach(a => {
    dict[`${a.row}-${a.column}`] = a;
  });
  return dict;
};
const getNumberOfCol = (type: null) => {
  if (type === SeatingType['2X2 (5)']) {
    return 5;
  } else if (type === SeatingType['3X3 (7)']) {
    return 7;
  }
  return 6;
};

export default function SeatingModelDetail({ seatingModel }: { seatingModel: TripSeatingModel }) {
  const { numberOfRow, numberOfCol, seatsMap } = React.useMemo(() => {
    if (seatingModel) {
      return {
        numberOfRow: seatingModel.noOfRows || 0,
        numberOfCol: getNumberOfCol(seatingModel.seatingType as any),
        seatsMap: toDict(seatingModel.seats || []),
      };
    }
    return {
      numberOfRow: 0,
      numberOfCol: 0,
      seatsMap: {},
    };
  }, [seatingModel]);
  return (
    <div id="seating-model">
      <div className="bus-model" id="bus-model">
        <div className="bus-header">
          <BusTopBg />
        </div>
        <div className="bus-container" style={{ backgroundImage: `url(${BusMiddleBg})` }}>
          <div className="seat-table">
            {range(0, numberOfRow).map(row => {
              return (
                <div className="row" key={row}>
                  {range(0, numberOfCol).map(col => {
                    const key = `${row}-${col}`;
                    let data = seatsMap[key];

                    return <div className="col bus-seat-item">{data ? <SeatDetail seat={data} /> : null}</div>;
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div className="bus-footer">
          <BusBottomBg />
        </div>
      </div>
    </div>
  );
}

type Props = {
  seat: AvailableSeatModel;
};

function SeatDetail({ seat }: Props) {
  if (seat.type === BusEntityType.Door) {
    return (
      <div className="seat-detail">
        <BusDoorIcon />
      </div>
    );
  }
  if (seat.type === BusEntityType.Fridge) {
    return (
      <div className="seat-detail">
        <FridgeIcon />
      </div>
    );
  }
  if (seat.type === BusEntityType.ToiletLeft) {
    return (
      <div className="seat-detail">
        <ToiletIcon style={{ transform: 'rotateY(180deg)' }} />
      </div>
    );
  }
  if (seat.type === BusEntityType.ToiletRight) {
    return (
      <div className="seat-detail">
        <ToiletIcon />
      </div>
    );
  }

  let color = seat.seatColor;
  if (seat.status !== SeatStatusType.Available) {
    color = SeatStatusType.__getColor(seat.status);
  }
  return (
    <div className="seat-detail">
      <SeatIcon style={{ fill: color || '#ccc', height: '70%' }} />
    </div>
  );
}
